export const hasFile = (value: unknown) => {
  return (
    (value instanceof File && value.size > 0) ||
    (value != null && typeof value === 'object' && 'doc' in value && value.doc instanceof File)
  );
};
